import type mapboxgl from 'mapbox-gl';
import { waitForFloorPlanSource, waitForStyle } from './mapSetup.js';
import type { FetcherContext, FetcherDependencies, FetcherState } from './types.js';

const createInitialState = (): FetcherState => ({
  previousStatuses: {},
  geometryCache: new Map(),
  missingGeometry: new Set(),
  visibleFeatureIds: [],
});

export const createFetcherContext = (deps: FetcherDependencies): FetcherContext => ({
  deps,
  state: createInitialState(),
});

export const getApiKeyOrLog = (context: FetcherContext) => {
  const meetingRoomAvailabilityApiKey = context.deps.meetingRoomAvailabilityApiKey;
  if (!meetingRoomAvailabilityApiKey) {
    console.error('meetingRoomAvailabilityApiKey query param is missing');
    return null;
  }

  return meetingRoomAvailabilityApiKey;
};

export const ensureMapReady = async (context: FetcherContext): Promise<mapboxgl.Map | null> => {
  const { mapsIndoorsInstance } = context.deps;
  if (!mapsIndoorsInstance) {
    throw new Error('MapsIndoors instance is not defined');
  }

  const mapView = mapsIndoorsInstance.getMapView();
  if (!mapView) {
    console.warn('Map view is not available yet');
    return null;
  }

  const mapboxMap = mapView.getMap();
  await waitForStyle(mapboxMap);
  await waitForFloorPlanSource(mapboxMap);
  return mapboxMap;
};
